import { EuiHealth, htmlIdGenerator } from "@elastic/eui";
import React from "react";

export const eduOptions = [
  {
    value: "Primary Education",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Primary Education
      </EuiHealth>
    ),
  },
  {
    value: "Secondary Education",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Secondary Education
      </EuiHealth>
    ),
  },
  {
    value: "Tertiary Education",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Tertiary Education
      </EuiHealth>
    ),
  },
];

export const provinceOptions = [
  {
    value: "Copperbelt",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Copperbelt
      </EuiHealth>
    ),
  },
  {
    value: "Northwestern",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Northwestern
      </EuiHealth>
    ),
  },
  {
    value: "Luapula",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Luapula
      </EuiHealth>
    ),
  },
  {
    value: "Lusaka",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Lusaka
      </EuiHealth>
    ),
  },
  {
    value: "Western",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Western
      </EuiHealth>
    ),
  },
  {
    value: "Southern",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Southern
      </EuiHealth>
    ),
  },
];

export const categoryOptions = [
  {
    value: "Entrepreneur",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Entrepreneur
      </EuiHealth>
    ),
  },
  {
    value: "R & D Institution",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        R & D Institution
      </EuiHealth>
    ),
  },
  {
    value: "Tertiary Institution",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Tertiary Institution
      </EuiHealth>
    ),
  },
];

export const sdgOptions = [
  {
    label: "SDG 1. No Poverty",
  },
  {
    label: "SDG 2. Zero Hunger",
  },
  {
    label: "SDG 3. Good Health and Well-Being",
  },
  {
    label: "SDG 4. Quality Education",
  },
  {
    label: "SDG 5. Gender Equality",
  },
  {
    label: "SDG 6. Clean Water and Sanitation",
  },
  {
    label: "SDG 7. Affordable and Clean Energy",
  },
  {
    label: "SDG 8. Decent Work and Economic Growth",
  },
  {
    label: "SDG 9. Industry, Innovation, and Infrastructure",
  },
  {
    label: "SDG 10. Reduced Inequalities",
  },
  {
    label: "SDG 11. Sustainable Cities and Communities",
  },
  {
    label: "SDG 12. Responsible Consumption and Production",
  },
  {
    label: "SDG 13. Climate Action",
  },
  {
    label: "SDG 14. Life Below Water",
  },
  {
    label: "SDG 15. Life on Land",
  },
  {
    label: "SDG 16. Peace, Justice, and Strong Institutions",
  },
];

export const natureOfProjectOptions = [
  {
    label: "Finance",
  },
  {
    label: "Agriculture",
  },
  {
    label: "Education",
  },
  {
    label: "Health",
  },
  {
    label: "Trade and Commerce",
  },
  {
    label: "Energy",
  },
];

const idPrefix = htmlIdGenerator()();

export const radios = [
  {
    id: `${idPrefix}0`,
    label: "Yes",
  },
  {
    id: `${idPrefix}1`,
    label: "No",
  },
];

export const permissions = [
  {
    id: `${idPrefix}0`,
    label: "Yes",
  },
  {
    id: `${idPrefix}1`,
    label: "No",
  },
];

// export const stageOptions = [
//   { label: "Idea" },
//   { label: "Prototype" },
//   { lable: "Final Product" },
// ];

export const stageOptions = [
  {
    value: "Idea",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Idea
      </EuiHealth>
    ),
  },
  {
    value: "Prototype",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Prototype
      </EuiHealth>
    ),
  },
  {
    value: "Final Product",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Final Product
      </EuiHealth>
    ),
  },
];

export const ipOptions = [
  {
    value: "Fully Protected",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Fully Protected
      </EuiHealth>
    ),
  },
  {
    value: "Provisionally Protected",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Provisionally Protected
      </EuiHealth>
    ),
  },
  {
    value: "Unprotected",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Unprotected
      </EuiHealth>
    ),
  },

  {
    value: "N/A",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        N/A
      </EuiHealth>
    ),
  },
];

export const purposeOptions = [
  {
    value: "Total Investment",
    inputDisplay: (
      <EuiHealth color="subdued" style={{ lineHeight: "inherit" }}>
        Total Investment
      </EuiHealth>
    ),
  },
  {
    value: "Equipment and machinery",
    inputDisplay: (
      <EuiHealth color="warning" style={{ lineHeight: "inherit" }}>
        Equipment and machinery
      </EuiHealth>
    ),
  },
  {
    value: "Product/process development",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Product/process development
      </EuiHealth>
    ),
  },

  {
    value: "Intellectual Property Protection",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Intellectual Property Protection
      </EuiHealth>
    ),
  },
  {
    value: "Concept and Market Testing",
    inputDisplay: (
      <EuiHealth color="danger" style={{ lineHeight: "inherit" }}>
        Concept and Market Testing
      </EuiHealth>
    ),
  },
];
